import { ContentBlockFragment, QualtricsFragment } from '@graphqlTypes/sitecore';
import { DiscoverQueryParams } from '@src/common/enums';
import { useGlobalStore } from '@src/hooks/use-global-store';
import { getSearchParams } from '@src/utils/query-string';
import Script from 'next/script';
import styles from './qualtrics.module.scss';
import { memo, useEffect, useState } from 'react';

const QualtricsCom = ({
    contentBlock,
    content,
}: {
    contentBlock: ContentBlockFragment;
    content: QualtricsFragment;
}) => {
    // console.log('QualtricsCom==================', content);
    const { settingStore } = useGlobalStore();
    const searchParams = getSearchParams();

    const [showSurvey, setShowSurvey] = useState(false);

    const getSeg = searchParams.getAll(DiscoverQueryParams.segment).join(',');
    const ac = searchParams.getAll(DiscoverQueryParams.account).join(',');
    const contentAc =
        contentBlock.accountListCodes?.targetItems &&
        contentBlock.accountListCodes?.targetItems?.length > 0
            ? contentBlock.accountListCodes?.targetItems?.map((item) => item.name).join(',')
            : '';

    const lang = /zh-HK/.test(
        typeof window !== 'undefined' && window.location && window.location.href
            ? window.location.href
            : ''
    )
        ? 'ZH-T'
        : 'EN';

    const transformedString = (originalString: string) => {
        return originalString.toLowerCase().replace(/_/g, '');
    };

    const qtId = content.interceptID?.value ?? 'ZN_72Hno6VSqE85ehE';

    console.log('qualtrics-ID----', content.interceptID?.value);

    useEffect(() => {
        setShowSurvey(true);
    }, [qtId]);

    return (
        <>
            {showSurvey && (
                <>
                    <Script
                        id='qualtricsText'
                        strategy='afterInteractive'
                        type='text/javascript'
                        dangerouslySetInnerHTML={{
                            __html: `
(function(){var g=function(e,h,f,g){

this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};

this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};

this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};

this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};

this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};

try{(new g(100,"r","QSI_S_${qtId}","https://${transformedString(
                                qtId
                            )}-hkjcapp.siteintercept.qualtrics.com/SIE/?Q_ZID=${qtId}")).start()}catch(i){}})();`,
                        }}
                    ></Script>
                    <div
                        id={qtId}
                        data-seg={getSeg || ''}
                        data-hashid={settingStore.wid || ''}
                        data-ac={ac || ''}
                        data-content-ac={contentAc}
                        data-lang={lang}
                        className={`${styles.qualtricsCss}`}
                    ></div>
                </>
            )}
        </>
    );
};

export default memo(QualtricsCom);
